import { useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Swal from "sweetalert2";

import * as authService from "@/services/auth";
import { AuthContext } from "@/providers/AuthProvider";

const useAuth = () => {
  const {
    name,
    role,
    email,
    workspaces,
    currentWorkspace,
    isLoggedIn,
    userType,
    setUserInfo,
    logout,
    isSubscriptionValid,
    resetPasswordToken,
    setIsSubscriptionValid,
  } = useContext(AuthContext);
  const location = useLocation();
  const navigate = useNavigate();

  const currentLocation = () => location.pathname;

  const handleLogin = async (email, password, idToken) => {
    const user = await authService.logIn({ email, password, idToken });
    setUserInfo({
      ...user,
    });
    return user;
  };

  const handleLogout = (isAutomaticLoggout = false, noShowWarnings = false) => {
    const actions = () => {
      authService.logOut();
      logout();
      navigate(`/login`);

      authService.setLastPage(currentLocation());
    };

    if (isAutomaticLoggout) {
      Swal.fire({
        icon: "info",
        title: "Você foi desconectado",
        text: "Por favor, faça login novamente para continuar.",
        timer: 3000,
        timerProgressBar: true,
      });

      return actions();
    }

    if (noShowWarnings) {
      return actions();
    }

    Swal.fire({
      icon: "warning",
      title: "Deseja realmente sair?",
      showCancelButton: true,
      confirmButtonText: "Sim",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        actions();
      }
    });
  };

  return {
    name,
    email,
    role,
    workspaces,
    currentWorkspace,
    isLoggedIn,
    userType,
    handleLogin,
    handleLogout,
    isSubscriptionValid,
    resetPasswordToken,
    setUserInfo,
    setIsSubscriptionValid,
  };
};

export default useAuth;
